import { FormModel } from "@coaching-culture/types";
import {
  Box,
  Text,
  Button,
  Loader,
  Modal,
  Circle,
  Flex,
} from "@coaching-culture/ui";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaQuestion } from "react-icons/fa";

export type FormPreviewModalProps = {
  formId: string;
  onClose: () => void;
};

export function FormPreviewModal({ formId, onClose }: FormPreviewModalProps) {
  const [form, setForm] = useState<FormModel | null>(null);

  useEffect(() => {
    axios.get(`/api/forms/${formId}`).then(({ data }) => {
      setForm(data);
    });
  }, [formId]);

  return (
    <Modal width={500} p={3}>
      {form == null ? (
        <Loader />
      ) : (
        <>
          <Text
            as="h2"
            mt={0}
            mb={3}
            fontSize="section"
            fontWeight={600}
            color="black"
          >
            Survey preview
          </Text>
          <Box mb={3}>
            {form.items
              .filter((x) =>
                ["free_text", "multiple_choice", "rating"].includes(x.type),
              )
              .map((x, i) => (
                <Flex mb={2} alignItems="center" key={i}>
                  <Circle color="primary" icon={FaQuestion} mr={2} />
                  <div>
                    <Text
                      fontWeight={500}
                      color="textMuted"
                      fontSize="caption"
                      mb="3px"
                    >
                      Question {i + 1}
                    </Text>
                    <Text>{x.content}</Text>
                  </div>
                </Flex>
              ))}
          </Box>
          <Button onClick={onClose} variant="primary">
            Close
          </Button>
        </>
      )}
    </Modal>
  );
}
